import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import CONSTANT from './../../../../../../shared/constants/constant';
import CustomExpandableTable from '../../../../../../shared/components/customExpandableTable';
import Pagination from './../../../../../../shared/components/pagination';
import VueMaterial from 'vue-material';
import BookingService from './../../../../../services/cargobooking.service';
import ClientService from './../../../../../../clientmanagement/services/clientmanagement.service';

export default {
  name: 'detailedinformation',
  components: {
    VueMaterial,
    CustomExpandableTable,
    Pagination,
    VueElementLoading
  },
  props:['bookingData'],
  data() {
    return {
      accordianTab:{1:false, 2:false,3:false,4:false},
      expanded:false,
      CompanyName:'',
      ATTN:'',
      Beneficiary:'',
      SelfCollectByClient:false,
      isDetailedInfoLoading:false,
      State:'',
      City:'',
      PinCode:'',
      HoldDays:'',
      ReferenceNo:'',
      EWBExpiryDate:'',
      InvoiceNumber:'',
      clientReferenceNo:'',
      AddNewConsigneeFlag:false,
      CompanyName:'',
      CSTTINNo:'',
      Telephone:'',
      Email:'',
      Mobile:'',
      EWBNumber:'',
      InvoiceValue:'',
      totalInvoiceValue:'',
      Address:'',
      VTCPayment:null,
      RequestedToTime:'',
      RequestedFromTime:'',
      CollectionAmount:'',
      Consignee:null,
      ConsigneeCode:'',
      RequestedDeliveryDate:'',
      detailedInformationData:[],
      userName:"",
      invoiceData:[],
      MallDelivery:"",
      productname:[],
      misccategory:''
    }
  },
  computed: {},
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.setValues(this.bookingData);

  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
    },
    expandAll(){
      this.expanded = true;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = true;
      }
    },
    collapseAll(){
      this.expanded = false;
      for (var key in this.accordianTab) {
        this.accordianTab[key] = false;
      }
    },
    toggleCheck(tabid){
      this.expanded = false;
      for (var key in this.accordianTab) {
        if(tabid != key){
          this.accordianTab[key] = false;
        }
      }
    },
    getTotalInvoiceValue(){
      let total=0;
      for(var i in this.invoiceData) { total += parseInt(this.invoiceData[i].invoicevalue); }
      return total;
    },
    setValues(data){
      this.detailedInformationData = data;
      this.bookingid = this.detailedInformationData.id;
      this.SelfCollectByClient = (this.detailedInformationData.pickbyclient==1)?"Yes":"No";
      this.PinCode = this.detailedInformationData.destinationpincode;
      this.City = this.detailedInformationData.consingneecity;
      this.State = this.detailedInformationData.consingneestate;
      this.ConsigneeCode = this.detailedInformationData.consingneecode;
      this.CompanyName = this.detailedInformationData.consingneename;
      this.Mobile = this.detailedInformationData.consingneemobile;
      this.ATTN = this.detailedInformationData.consingneeattn;
      this.Telephone = this.detailedInformationData.consingneetelephone;
      this.Email = this.detailedInformationData.consingneeemail;
      this.CSTTINNo = this.detailedInformationData.consingneecsttin;
      this.Address = this.detailedInformationData.consingneeaddress;
      this.ReferenceNo = this.detailedInformationData.refnumber;
      this.clientReferenceNo = this.detailedInformationData.clientrefnumber;
      this.RequestedDeliveryDate = this.detailedInformationData.requesteddeliverydate;
      this.RequestedFromTime = this.detailedInformationData.requesteddeliverytimefrom;
      this.RequestedToTime = this.detailedInformationData.requesteddeliverytimeto;
      this.HoldDays = this.detailedInformationData.holddelivery;
      this.CollectionAmount = this.detailedInformationData.collectionamount;
      this.VTCPayment = this.detailedInformationData.vtcpaymentmode;
      this.Beneficiary = this.detailedInformationData.benificiary;
      this.invoiceData = this.detailedInformationData.invoicedetails;
      this.totalInvoiceValue = this.detailedInformationData.totalinvoicevalue;
      this.MallDelivery=(this.detailedInformationData.malldelivery==1)?'Yes':'No';
      this.misccategory = this.detailedInformationData.misccategory;
      if (this.detailedInformationData.productcategories) {
        for (var i = 0; i < this.detailedInformationData.productcategories.length; i++) {
          this.productname.push(this.detailedInformationData.productcategories[i].label)
        }
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/bookingListing/bookingview/detailedinformation/detailedinformation.component.js